<template>
  <div class="d-contents">
    <div v-for="tax in joinedTaxes" :key="tax.id" class="offers-table-cell_tax-container">
      <div
        class="offers-table-cell_tax-wrapper"
        :class="{
          'offers-table-cell_tax-draft': isDraft,
          'offers-table-cell_tax-create': !tax.updateTax,
        }"
      >
        <div
          v-if="tax.updateTax"
          class="offers-table-cell_tax"
          @click="
            $emit('open-tax-modal', {
              offerTaxId: tax.id,
              taxName: tax.name,
              taxValue: tax.percent_total,
              taxId: tax.tender_tax_id,
              updateTax: true,
            })
          "
        >
          <div class="text spacex-4 fs-14 fw-5">
            <span class="text text-grey fs-14">{{ currencySymbols[currency] }}</span>
            <span>{{ addSpaces(tax.total) }}</span>
          </div>
          <div class="grey-500 text-sm offers-table-cell_tax-text">
            {{ tax.name }} ({{ tax.percent_total }}%)
          </div>
        </div>
        <div v-else-if="isDraft" class="offers-table-cell_tax-container">
          <Button
            type="ghost"
            fill
            size="small"
            left-icon="plus"
            @click="
              $emit('open-tax-modal', {
                taxName: tax.name,
                taxValue: tax.percent_total,
                taxId: tax.id,
                updateTax: false,
              })
            "
          >
            {{ tax.name }}
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Button from '@/components/ui/Button';
  import addSpaces from '@/utils/formatting/add-spaces';
  import { mapState } from 'vuex';

  export default {
    name: 'TaxesOfColumn',
    components: {
      Button,
    },
    props: {
      isDraft: {
        type: Boolean,
        required: true,
      },
      offer: {
        type: Object,
        required: true,
      },
      currency: String,
      taxes: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      ...mapState('global', ['currencySymbols']),
      offerTaxes() {
        return this.offer.taxes;
      },
      joinedTaxes() {
        return this.taxes.map((tax) => {
          let filledTax = this.offerTaxes.find((offerTax) => offerTax.tender_tax_id === tax.id);
          return filledTax
            ? {
                ...tax,
                ...filledTax,
                updateTax: true,
              }
            : { ...tax, updateTax: false };
        });
      },
    },
    methods: {
      addSpaces,
    },
  };
</script>
